<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMeetingRoom_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M20.25 3.5H3.75A3.754 3.754 0 0 0 0 7.25v10.5a3.754 3.754 0 0 0 3.75 3.75h16.5A3.754 3.754 0 0 0 24 17.75V7.25a3.754 3.754 0 0 0-3.75-3.75M12 7.08a3.455 3.455 0 0 1 3.451 3.45A3.455 3.455 0 0 1 12 13.983a3.455 3.455 0 0 1-3.451-3.451A3.454 3.454 0 0 1 12 7.08M17.563 20H6.437a.942.942 0 0 1-.93-1.08c.169-1.082.58-1.5.82-1.762.893-.975 2.593-1.702 5.673-1.702 3.054 0 4.75.715 5.65 1.677.26.277.674.702.843 1.786a.942.942 0 0 1-.93 1.081"
    />
</svg>
